import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import Dummy from "../../assets/images/No_Image_Available.jpg"
import { Link, useNavigate } from "react-router-dom";
import { withTranslation } from 'react-i18next';

const DatatableTables = ({ t }) => {
  const navigate = useNavigate(); 
  const [data, setData] = useState({
    columns: [
      // {
      //   label: t("Select"),
      //   field: "select",
      //   sort: "asc",
      //   width: 50,
      // },
      {
        label: t("ID"),
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Image"),
        field: "image",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Name"),
        field: "first_name",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Gender"),
        field: "gender",
        sort: "asc",
        width: 270,
      },
      {
        label: t("Email"),
        field: "email",
        sort: "asc",
        width: 200,
      },
      {
        label: t("Activation Status"),
        field: "status",
        sort: "asc",
        width: 150,
      },
      {
        label: t("Last Login"),
        field: "last_login",
        sort: "asc",
        width: 100,
      },
      {
        label: t("Edit"),
        field: "edit",
        sort: "asc",
        width: 100,
      },
    ],
    rows: []
  });
  
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const getUsersData = async (page) => {
    try {
      const usersData = await get(`v1/users/?user_type=Patient&page=${page}&page_size=10`);
      setData(prevState => ({ ...prevState, rows: usersData.results }));
      console.log(usersData,"usersData")
      setTotalPages(usersData.total_pages);
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUsersData(currentPage);
  }, [currentPage]);

  const handleEdit = (id) => {
    navigate(`/users/${id}`);
    console.log("Edit button clicked for user with ID:", id);
  };

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleButtonClick = () => {
    const selectedIds = selectedRows;
    console.log("Selected IDs:", selectedIds);
  };

  const handleButtonCreate = () => {
    navigate(`/users/create-user`);
    // console.log("Selected IDs:", );
  };

  const paginationOptions = {
    entries: 10,
    responsive: true,
    striped: true,
    bordered: false,
    searchLabel: t('Search'),
    info: true,
    infoLabel: [t('Showing'), t('to'), t('of'), t('entries')],
    paginationLabel: ['<', '>'],
    noRecordsFoundLabel: t(isLoading ? "Loading..." :'No records found'),
    searchPlaceholder: t('Search')
  };

  document.title = "Data Tables | Llosana";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle={t("Home")} title={t("Data")} breadcrumbItem={t("Users")} />
          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                <CardTitle className="h4">{t("Users Listing")}</CardTitle>
                  <MDBDataTable
                    exportToCSV={true}
                    data={{
                      columns: data.columns,
                      rows: isLoading ? [] : data.rows.map(row => ({
                        ...row,
                        select: <input type="checkbox" checked={selectedRows.includes(row.id)} onChange={() => handleCheckboxChange(row.id)} />,
                        image: <img src={`${row.profile_image || Dummy}`} alt="User" width="50" height="50" />,
                        edit: <Button color="primary" onClick={() => handleEdit(row.id)}>{t("Edit")}</Button>,
                        status: row.status ? t('True') : t('False'),
                        last_login: row.last_login instanceof Date ? row.last_login.toLocaleDateString() : row.last_login
                      }))
                    }}
                    responsive={paginationOptions.responsive}
                    striped={paginationOptions.striped}
                    bordered={paginationOptions.bordered}
                    searching={true}
                    searchLabel={paginationOptions.searchLabel}
                    info={paginationOptions.info}
                    infoLabel={paginationOptions.infoLabel}
                    paging={false}
                    paginationLabel={paginationOptions.paginationLabel}
                    entries={paginationOptions.entries}
                    noRecordsFoundLabel={paginationOptions.noRecordsFoundLabel}
                    searchingLabel={paginationOptions.searchPlaceholder}
                  />
                  {/* <Button onClick={handleButtonClick}>{t("Get Selected IDs")}</Button> */}
                  <Button color="primary" onClick={handleButtonCreate}>
                    <i className="typcn typcn-plus"></i>{t("Create New User")}</Button>

                  <MDBPagination className="mt-3">
                    <MDBPaginationItem disabled={currentPage === 1}>
                      <MDBPaginationLink onClick={() => setCurrentPage(currentPage - 1)}>{t("Previous")}</MDBPaginationLink>
                    </MDBPaginationItem>
                    {[...Array(totalPages).keys()].map(page => (
                      <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                        <MDBPaginationLink onClick={() => setCurrentPage(page + 1)}>{page + 1}</MDBPaginationLink>
                      </MDBPaginationItem>
                    ))}
                    <MDBPaginationItem disabled={currentPage === totalPages}>
                      <MDBPaginationLink onClick={() => setCurrentPage(currentPage + 1)}>{t("Next")}</MDBPaginationLink>
                    </MDBPaginationItem>
                  </MDBPagination>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(DatatableTables);
